import React from "react";

type AlertType = "success" | "failure" | "warning" | "info";

interface AlertProps {
    message: React.ReactNode;
    message2?: React.ReactNode;
    type?: AlertType;
    className?: string;
}

const colorMap: Record<AlertType, { text: string; bg: string; srLabel: string }> = {
    success: { text: "text-green-700", bg: "bg-green-100", srLabel: "Success" },
    failure: { text: "text-red-700", bg: "bg-red-100", srLabel: "Error" },
    warning: { text: "text-yellow-700", bg: "bg-yellow-100", srLabel: "Warning" },
    info: { text: "text-blue-700", bg: "bg-blue-100", srLabel: "Info" },
};

class Alert extends React.Component<AlertProps> {
    render() {
        const { message, message2, type = "failure", className = "" } = this.props;
        const colors = colorMap[type] ?? colorMap.failure;

        return (
            <div
                className={`flex p-4 my-4 text-sm ${colors.text} ${colors.bg} rounded-lg w-full ${className}`}
                role="alert"
            >
                <svg
                    aria-hidden="true"
                    className="flex-shrink-0 inline w-5 h-5 mr-3"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fillRule="evenodd"
                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                        clipRule="evenodd"
                    ></path>
                </svg>
                <span className="sr-only">{colors.srLabel}</span>
                <div className="text-center">
                    {message}
                    {message2 ? (
                        <>
                            <br />
                            {message2}
                        </>
                    ) : null}
                </div>
            </div>
        );
    }
}

export default Alert;
